import React from 'react'
import { Redirect } from 'react-router-dom'

class CouponBusinessRedirect extends React.PureComponent {
  render() {
    if (this.props.location && this.props.location.search) {
      const search = this.props.location.search.replace('?business=', '')
      return <Redirect to={{ pathname: `/coupons`, state: {business: search} }} />
    } else {
      return ''
    }
  }
}

export default CouponBusinessRedirect



// WEBPACK FOOTER //
// ./src/js/components/CouponBusinessRedirect.js